module.exports = __webpack_public_path__ + "static/media/wave-grc-2.4c696302.svg";